import React, { useEffect } from "react";
import { Form, Row, Col, InputGroup } from "react-bootstrap";
import {
  IconUser,
  IconFileDescription,
  IconCalendarWeek,
} from "@tabler/icons-react";
import { useFormContext, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";

function GeneralPublicForm({ isEditing, onOrderIDBlur, orderId }) {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const rmaTypeSelected = watch("rmaType");

  // Set default rmaType if it's not set
  useEffect(() => {
    if (!rmaTypeSelected) {
      setValue("rmaType", "EXCHANGE");
    }
  }, [setValue, rmaTypeSelected]);

  // Set the Order ID from the prop (only if it's not being edited)
  // useEffect(() => {
  //   if (orderId && !isEditing) {
  //     setValue("orderId", orderId);
  //   }
  // }, [orderId, isEditing, setValue]);

  console.log("orderId received from parent is", orderId);

  return (
    <>
      <Row className="mb-3 mt-3">
        <Form.Group as={Col}>
          <div style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}>
            <Form.Label className="w-md-auto" style={{ fontWeight: "bold" }}>
              RMA Type:
            </Form.Label>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="RMAId"
                value="EXCHANGE"
                {...register("rmaType")}
              />
              <Form.Check.Label htmlFor="RMAId">Exchange</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="RMAId"
                value="RETURN"
                {...register("rmaType")}
              />

              <Form.Check.Label htmlFor="RMAId">Return</Form.Check.Label>
            </Form.Check>
          </div>
        </Form.Group>
      </Row>

      <Row className="">
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Order ID</Form.Label>
            <InputGroup>
              <Form.Control
                {...register("orderId")}
                placeholder="Enter Order ID"
                // onBlur={(e) => {
                //   register("orderId").onBlur(e);
                //   onOrderIDBlur?.();
                // }}
                disabled
              />
            </InputGroup>
            {errors.orderId && (
              <span className="text-danger">{errors.orderId.message}</span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label className="required">RMA ID</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                {...register("rma_id")}
                placeholder="Enter RMA ID"
                defaultValue={"N/A"}
                disabled={isEditing}
              />
            </InputGroup>
            {errors.rma_id && (
              <span className="text-danger">{errors.rma_id.message}</span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Manufacturer RMA ID</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                {...register("manufacturer_id")}
                placeholder="Enter Manufacturer's RMA ID"
              />
            </InputGroup>
            {errors.manufacturer_id && (
              <span className="text-danger">
                {errors.manufacturer_id.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Organization/Agency Name</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                {...register("organization_name")}
                placeholder="Enter agency Name"
              />
            </InputGroup>
            {errors.organization_name && (
              <span className="text-danger">
                {errors.organization_name.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>RMA Description</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                {...register("rma_Description")}
                placeholder="Enter Description"
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
              />
            </InputGroup>
            {errors.rma_Description && (
              <span className="text-danger">
                {errors.rma_Description.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row className="">
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Tracking Number</Form.Label>
            <InputGroup>
              <Form.Control
                type="number"
                {...register("trackingID")}
                placeholder="Enter Tracking Number"
              />
            </InputGroup>
            {errors.trackingID && (
              <span className="text-danger">{errors.trackingID.message}</span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Date Reported</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="publishedDate"
                control={control}
                defaultValue={new Date()}
                rules={{ required: "Published date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value ? new Date(field.value) : new Date()}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control required"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                  />
                )}
              />
            </InputGroup>
            {errors.publishedDate && (
              <span className="text-danger">
                {errors.publishedDate.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Estimated Return Date</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="estimatedDate"
                control={control}
                rules={{ required: "Estimated Return date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control required"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                  />
                )}
              />
            </InputGroup>
            {errors.estimatedDate && (
              <span className="text-danger">
                {errors.estimatedDate.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Actual Return Date</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="actualDate"
                control={control}
                rules={{ required: "Actual Return date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control required"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                  />
                )}
              />
            </InputGroup>
            {errors.actualDate && (
              <span className="text-danger">{errors.actualDate.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}

export default GeneralPublicForm;
